import React, { useState } from "react";
import { useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form"

//import axios from 'axios';
import axios_api from "../../Api";

import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../../Context';


export function TicketUpdateForm ({ticketId, UpdateChat}) {

  //const media_url = useContext(MEDIA_URL);
  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);
  const navigate = useNavigate();
  const [formError, setFormError] = useState(false)

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });


  const onSubmit = (ticketData) => {

    let data = {...ticketData};

    console.log(data);

    axios_api.put(api_url + `/manage_ticket/` + ticketId, data, {
      //paramsSerializer: { indexes: null },
      headers: {
        "Authorization": token, 
        "Content-Type": "multipart/form-data",
      }
    })
    .then(
      (result) => {
        console.log("success");
        navigate("/ticket/" + ticketId);
        navigate(0);
      },
      (error) => {
        const errorMessage = error.request.status === 413 ? 
            'Размер файла превышает разрешенный размер на web-сервере' : 
              error.response?.data || 
                'Ошибка добавления документа';
        setFormError(errorMessage);
        //console.log(error);
      }
    );
  }

  return (
    <>
    <div className="lk-form">
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <div className="input-group mb-3">  
          <label className="col-4">
            <p>Сообщение</p>
            <textarea className="form-control" rows="2"  style={{width: '400px'}} {...register("text")} ></textarea>
          </label>
        </div>
        <div className="input-group mt-3">
          <label className="">
            <p>Вложение</p> 
            <input type="file" className="form-control" style={{width: '400px'}} {...register('attachment')}/>
          </label>
        </div>
        <p className="text-secondary mt-1"><small>максимальный размер файла 10 мб</small></p>
        { formError &&
          <p className="text-danger">{formError}</p>
        }
        {(20 > 10) ?
          <button type="submit" className="btn lk-button my-3">Отправить</button>
        :
          <button type="button" className="btn lk-button my-3" disabled>Отправить</button>
        }
      </form>
    </div>
    </>  
  )
}
